import { Component, HostListener } from '@angular/core';
import { LandingThemesService } from './themes.service';

@Component({
  selector: 'landing-themes-section',
  templateUrl: './themes.component.html',
  styleUrls: ['./themes.component.scss'],
})
export class LandingThemesSectionComponent {
  themes = [];
  modalOpen = false;
  styles = null;
  themeType = null;

  constructor(public themesService: LandingThemesService) {
    this.themes = themesService.get();
  }

  openModal(i) {
    this.styles = this.themes[i].styles;
    this.modalOpen = true;
    this.themeType = this.themes[i].title;
  }

  @HostListener('window:keydown.escape', ['$event'])
  closeModal() {
    this.modalOpen = false;
  }

  getRandomThemeStyles() {
    const random = Math.floor(Math.random() * this.themes.length);
    return this.themes[random].styles;
  }
}
